export default {"src":"/a/r/be1.9/_next/static/media/warning.ade8160c.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};